export const messages = {
  title: {
    id: 'patientInformation.Title',
    defaultMessage: 'Patient Information',
  },
  subTitle: {
    demographics: {
      id: 'patientInformation.SubTitle.Demographics',
      defaultMessage: 'Demographics',
    },
    contactInformation: {
      id: 'patientInformation.SubTitle.ContactInformation',
      defaultMessage: 'Contact Information',
    },
    other: {
      id: 'patientInformation.SubTitle.Other',
      defaultMessage: 'Other',
    },
  },
  label: {
    fullName: {
      id: 'patientInformation.Label.FullName',
      defaultMessage: 'Full Name',
    },
    gender: {
      id: 'patientInformation.Label.Gender',
      defaultMessage: 'Gender',
    },
    dateOfBirth: {
      id: 'patientInformation.Label.DateOfBirth',
      defaultMessage: 'Date of Birth',
    },
    birthCountry: {
      id: 'patientInformation.Label.BirthCountry',
      defaultMessage: 'Birth Country',
    },
    ethnicity: {
      id: 'patientInformation.Label.Ethnicity',
      defaultMessage: 'Ethnicity',
    },
    race: {
      id: 'patientInformation.Label.Race',
      defaultMessage: 'Race',
    },
    religion: {
      id: 'patientInformation.Label.Religion',
      defaultMessage: 'Religion',
    },
    primaryLanguage: {
      id: 'patientInformation.Label.PrimaryLanguage',
      defaultMessage: 'Primary Language',
    },
    citizenship: {
      id: 'patientInformation.Label.Citizenship',
      defaultMessage: 'Citizenship',
    },
    maritalStatus: {
      id: 'patientInformation.Label.MaritalStatus',
      defaultMessage: 'Marital Status',
    },
    mothersMaidenName: {
      id: 'patientInformation.Label.MothersMaidenName',
      defaultMessage: 'Mother\'s Maiden Name',
    },
    occupation: {
      id: 'patientInformation.Label.Occupation',
      defaultMessage: 'Occupation',
    },
    home: {
      id: 'patientInformation.Label.Home',
      defaultMessage: 'Home',
    },
    mobile: {
      id: 'patientInformation.Label.Mobile',
      defaultMessage: 'Mobile',
    },
    primaryEmail: {
      id: 'patientInformation.Label.PrimaryEmail',
      defaultMessage: 'Primary Email',
    },
    preferredCommunication: {
      id: 'patientInformation.Label.PreferredCommunication',
      defaultMessage: 'Preferred Communication',
    },
    address: {
      id: 'patientInformation.Label.Address',
      defaultMessage: 'Address 1',
    },
    address2: {
      id: 'patientInformation.Label.Address2',
      defaultMessage: 'Address 2',
    },
    city: {
      id: 'patientInformation.Label.City',
      defaultMessage: 'City',
    },
    state: {
      id: 'patientInformation.Label.State',
      defaultMessage: 'State',
    },
    country: {
      id: 'patientInformation.Label.Country',
      defaultMessage: 'Country',
    },
    insurance: {
      id: 'patientInformation.Label.Insurance',
      defaultMessage: 'Insurance',
    },
    advanceDirective: {
      id: 'patientInformation.Label.AdvanceDirective',
      defaultMessage: 'Advance Directive',
    },
    clinicalTrial: {
      id: 'patientInformation.Label.ClinicalTrial',
      defaultMessage: 'Clinical Trial',
    },
  },
};
